import React, { useEffect, useState } from "react";
import { Avatar, Divider, Tab, Tabs, Typography } from "@material-ui/core";
import {
  useData,
  productsRewardCollection,
} from "../../../components/firebase/DataProvider";
import { date } from "../../../utils/dateTime";
import Header from "../../../components/molecules/Header";
import useStyles from "./style";
import defaultLogo from "../../../assets/images/landing-image-third.png";
import currency from "../../../utils/currency";
import ProdukReward from "./produkReward";
import { useHistory } from "react-router-dom";
import RiwayatReward from "./riwayatReward";
import RiwayatPoint from "./riwayatPoint";
import {
  firefunctions,
  firestore,
} from "../../../components/firebase/FirebaseProvider";

function RewardPoint() {
  const classes = useStyles();
  const history = useHistory();
  const { point, kredit, penukaran, webstore } = useData();
  const lastVisible = React.useRef();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [multiplier, setMultiplier] = useState(false);
  const [filter, setFilter] = useState("produk");
  const [rewardPointConfig, setRewardPointConfig] = useState(null);

  const handleChangeTab = (event, value) => {
    setFilter(value);
  };

  const bergabung = React.useMemo(() => {
    if (
      webstore?.created_at &&
      typeof webstore?.created_at.seconds === "number" &&
      typeof webstore?.created_at.nanoseconds === "number"
    ) {
      return date(webstore?.created_at.toDate());
    }

    return "Tidak diketahui";
  }, [webstore?.created_at]);

  const PointAll = point.reduce(function (prev, curr) {
    return prev + curr.nilai;
  }, 0);

  const PenukaranAll =
    (kredit?.total_penukaran_reward_approved ?? 0) +
    (kredit?.total_penukaran_reward_pending ?? 0);

  const MyPoints = PointAll - PenukaranAll;
  let kumulasi = kredit ? kredit.total_kumulasi_hitung_point : 0;
  let kumulasiDiskon = kredit ? kredit?.total_kumulasi_hitung_point_diskon : 0;
  let kumulasiTotal = kredit
    ? (kredit?.total_kumulasi_hitung_point_diskon ?? 0) +
      (kredit.total_kumulasi_hitung_point ?? 0)
    : 0;

  useEffect(() => {
    const productsRef = productsRewardCollection;
    async function getProducts() {
      setLoading(true);
      setProducts([]);

      const utilityCol = firestore?.collection("utility");
      const voucherData = await utilityCol?.doc("reward_point")?.get();
      setMultiplier(voucherData?.data()?.multiplier);
      setRewardPointConfig(voucherData.data());
      // console.log("lwt");
      if (
        (voucherData?.data()?.multiplier ?? 1) < 2 &&
        kumulasiTotal >= 1000000
      ) {
        // console.log("lewat");
        const claimAPI = firefunctions.httpsCallable("reward_point-claim");
        await claimAPI({});
      }

      const query = await productsRef
        .where("sembunyikan_produk", "==", false)
        .get();

      if (!query.empty) {
        const newProducts = await Promise.all(
          query.docs.map(async (product) => {
            const variants = await product.ref.collection("variants").get();
            return {
              id: product.id,
              ...product.data(),
              variants: variants.docs.map((variant) => {
                return {
                  id: variant.id,
                  ...variant.data(),
                };
              }),
            };
          })
        );
        setProducts((products) => [...products, ...newProducts]);
      }

      setLoading(false);
    }

    getProducts();
  }, []);

  return (
    <>
      <Header
        type="with-title"
        onClick={() => history.goBack()}
        title="Reward Point"
      />
      {/* <Container> */}
      {/* <div style={{ minWidth: "390px", backgroundColor: "#FEFEFE" }}> */}
      <div className={classes.wrapHeaderToko}>
        <div className={classes.wrapAvatar}>
          <Avatar
            alt={webstore?.nama}
            className={classes.large}
            src={!webstore?.logo ? defaultLogo : webstore?.logo}
            title="Logo"
          />
        </div>
        <div className={classes.wrapDetail}>
          <Typography className={classes.liquidValue} color="primary">
            {point ? MyPoints : 0} point
          </Typography>
          {multiplier < 2 ? null : (
            <Typography align="center" className={classes.liquidAlert}>
              point yang diraih akan di kali <b>{multiplier}</b> sampai batas
              waktu yang telah ditentukan oleh pihak Tokorame
            </Typography>
          )}
          <div
            style={{
              display: "flex",
              minWidth: "90%",
              justifyContent: "space-evenly",
              border: "1px solid rgba(0, 0, 0, 0.12)",
              borderRadius: "8px",
              marginTop: "10px",
            }}
          >
            <div
              style={{
                marginTop: "20px",
                marginBottom: "20px",
                marginLeft: "10px",
                marginRight: "10px",
                textAlign: "center",
              }}
            >
              {multiplier < 2 && (rewardPointConfig?.cummulative_divider === rewardPointConfig?.cummulative_with_disc_divider) ? (
                <>
                  <Typography className={classes.liquidTitle}>
                    {bergabung}
                  </Typography>
                  <Typography className={classes.liquidLabel}>
                    bergabung dengan Tokorame
                  </Typography>
                </>
              ) : (
                <>
                  <Typography className={classes.liquidTitle}>
                    {currency(kumulasi)}
                  </Typography>
                  <Typography className={classes.liquidLabel}>
                    Kumulasi pembelian produk biasa
                  </Typography>
                </>
              )}
            </div>
            <div style={{ marginTop: "15px", marginBottom: "15px" }}>
              <Divider orientation="vertical" />
            </div>
            <div
              style={{
                marginTop: "20px",
                marginBottom: "20px",
                marginLeft: "10px",
                marginRight: "10px",
                textAlign: "center",
              }}
            >
              {multiplier < 2 && (rewardPointConfig?.cummulative_divider === rewardPointConfig?.cummulative_with_disc_divider) ? (
                <>
                  <Typography className={classes.liquidTitle}>
                    {currency(kumulasiTotal)}
                  </Typography>
                  <Typography className={classes.liquidLabel}>
                    Kumulasi pembelian semua produk
                  </Typography>
                </>
              ) : (
                <>
                  <Typography className={classes.liquidTitle}>
                    {currency(kumulasiDiskon)}
                  </Typography>
                  <Typography className={classes.liquidLabel}>
                    Kumulasi pembelian produk diskon
                  </Typography>
                </>
              )}
            </div>
            {/* <Typography className={classes.liquidLabel}>
              {bergabung} | Kumulasi Rp.
              {kumulasi ? numberFormat(kumulasi) : 0}
            </Typography> */}
          </div>
        </div>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Tabs
          indicatorColor="primary"
          variant="fullWidth"
          value={filter}
          onChange={handleChangeTab}
        >
          <Tab
            style={{ textTransform: "capitalize", fontSize: "13px" }}
            label="Produk Reward"
            value="produk"
          />
          <Tab
            style={{ textTransform: "capitalize", fontSize: "13px" }}
            label="Riwayat Reward"
            value="reward"
          />
          <Tab
            style={{ textTransform: "capitalize", fontSize: "13px" }}
            label="Riwayat Point"
            value="point"
          />
        </Tabs>
      </div>
      <div style={{ backgroundColor: "#efefef" }}>
        <ProdukReward
          value={filter}
          loading={loading}
          products={products}
          index="produk"
          MyPoints={MyPoints}
        />
        <RiwayatReward
          value={filter}
          // loading={loading}
          penukaran={penukaran}
          index="reward"
        />
        <RiwayatPoint
          value={filter}
          // loading={loading}
          point={point}
          index="point"
        />
      </div>
      {/* </div> */}
    </>
  );
}

export default RewardPoint;
